import React from 'react';
import moment from 'moment';
import { useAureliaI18n } from '../../../react-hooks/useAureliaI18n';
import useChoice from '../../../react-hooks/useChoice';
import { formatMilitaryTime } from './helpers/cellFormatters';
import { getChoiceLabel } from './helpers/getChoiceLabel';

const OpeningDay = ({ openingDay, dayChoices }) => (
    <>
        <span className="list-without-space">
            {openingDay.daysOfWeek?.map((day, dayIndex) => (
                <React.Fragment key={dayIndex}>
                    <span>{getChoiceLabel(dayChoices, day)}</span>
                    {dayIndex < openingDay.daysOfWeek.length - 1 && (
                        <span className="separator">, </span>
                    )}
                </React.Fragment>
            ))}
            <span className="separator">: </span>
            {openingDay.times?.map((time, timeIndex) => (
                <React.Fragment key={timeIndex}>
                    <span>
                        {formatMilitaryTime(time.from)} - {formatMilitaryTime(time.to)}
                    </span>
                    {timeIndex < openingDay.times.length - 1 && (
                        <span className="separator">, </span>
                    )}
                </React.Fragment>
            ))}
        </span>
        {openingDay.validities?.length > 0 && (
            <span className="list-without-space">
                <i>Gültigkeit:&nbsp;</i>
                {openingDay.validities.map((validity, validityIndex) => (
                    <React.Fragment key={validityIndex}>
                        <i>
                            {moment(validity.validFrom).format('L')} -{' '}
                            {moment(validity.validTo).format('L')}
                        </i>
                        {validityIndex < openingDay.validities.length - 1 && (
                            <span className="separator">, </span>
                        )}
                    </React.Fragment>
                ))}
            </span>
        )}
    </>
);

const OpeningTimes = ({ params }) => {
    const value = params?.value;
    const { t } = useAureliaI18n();
    const dayChoices = useChoice({ type: 'dayOfWeekAbbreviation', getAll: true });

    if (!value) {
        return <></>;
    }

    if (value.permanentlyOpen) {
        return <span>{t('base.permanentlyOpen')}</span>;
    }

    return (
        <>
            {value.days?.map((openingDay, index) => (
                <OpeningDay key={index} openingDay={openingDay} dayChoices={dayChoices} />
            ))}
        </>
    );
};

export default OpeningTimes;
